import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// react plugin for creating charts
import ChartistGraph from "react-chartist";
// react plugin for creating vector maps

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import InfoOutline from "@material-ui/icons/InfoOutline";
import Group from "@material-ui/icons/Group";
import DateRange from "@material-ui/icons/DateRange";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Face from "@material-ui/icons/Face";
import Check from "@material-ui/icons/Check";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Table from "beaktShared/components/Table/Table.js";
import Card from "beaktShared/components/Card/Card.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import moment from "moment";
import { formateDate} from "beaktShared/helpers/masks";

import {
  dailySalesChart,
  emailsSubscriptionChart,
} from "beaktDay/views/AdminAgenda/Dashboard/charts";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  const classes = useStyles();
  const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };

    useEffect(() => {
      loadAgbyDate(); 
      loadProximos10Agendamentos(); 
      loadProfissionaisxAg();
   // eslint-disable-next-line   
   }, []);

  const [isLoadingtotalAgendamento, setisLoadingtotalAgendamento] = React.useState(false);
  const [totalizadorAg, settotalizadorAg] = React.useState([]);
  const loadAgbyDate = () =>{       
      var date = new Date(); 
      date = moment(date).format()

      const endPoint = "agendamentos/totalagendamentobydate/"+date+"/"+session.estabelecimentoId;
  
      setisLoadingtotalAgendamento(true);
      UseGetApiSimple(endPoint,0).then(result=>{        
          if(result.status !== 200)
          {                                     
              showNotification(result.message,'danger');
              setisLoadingtotalAgendamento(false);
              return false; 
          }             
          settotalizadorAg(result.data);
          setisLoadingtotalAgendamento(false);
          return true;                
      });  
  }

  const [isLoadingProximos10, setisLoadingProximos10] = React.useState(false);
  const [listProximos10, setlistProximos10] = React.useState([]);
  const loadProximos10Agendamentos = () =>{        
  const endPoint = "agendamentos/proximos10/"+session.estabelecimentoId;
    setisLoadingProximos10(true);
    UseGetApiSimple(endPoint,0).then(result=>{         
        if(result.status !== 200)
        {                                     
            showNotification(result.message,'danger');
            setisLoadingProximos10(false);
            return false; 
        }     
        
        var lstdata = [];
        result.data.map(item =>{
            
           var datahora = formateDate(item.data)
           datahora = datahora +" - "+ item.horaInicio
            var ag = [
                item.nomeCliente,
                item.descricaoServico,
                datahora                    
            ]
            lstdata.push(ag);
         })
      
        setlistProximos10(lstdata);
        setisLoadingProximos10(false);
        return true;                
    });  
  }


  const [isLoadingProfixAgend, setisLoadingProfixAgend] = React.useState(false);
  const [listProfixAgend, setlistProfixAgend] = React.useState([]);
  const loadProfissionaisxAg = () =>{        
  const endPoint = "agendamentos/profissionaisxAg/"+session.estabelecimentoId;
  setisLoadingProfixAgend(true);
    UseGetApiSimple(endPoint,0).then(result=>{         
        if(result.status !== 200)
        {                                     
            showNotification(result.message,'danger');
            setisLoadingProfixAgend(false);
            return false; 
        }     
        
        var lstdata = [];
        result.data.map(item =>{
            
            var row = [
                item.profissionalNome,
                "Total: "+item.totalAgendamento,  
                "Confirmado: "+item.totalConfirmado,
                "Pendente: "+item.totalPendente, 
                "Cancelado: "+item.totalCencelado,          
            ]
            lstdata.push(row);
         })
      
        setlistProfixAgend(lstdata);
        setisLoadingProfixAgend(false);
        return true;                
    });  
  }

  return (
    <div>  
      
      <Snackbar
          place="tr"
          color={colorNotification}
          message={mensagemNotification}
          open={notification}
          closeNotification={() => setNotification(false)}
          close
      />

      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>bookmarks</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>{t('information_message.schedules_of_the_day')} </p>
              <h3 className={classes.cardTitle}>
                {!isLoadingtotalAgendamento && totalizadorAg.total} 
              </h3>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  {t('label.View_all')}
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
        <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>hourglass_empty</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.pending_appointments')} </p>
              <h3 className={classes.cardTitle}>
                {!isLoadingtotalAgendamento && totalizadorAg.totalPendente} 
              </h3>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>          
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
        <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Check />
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.confirmed_schedules')} </p>
              <h3 className={classes.cardTitle}>
                {!isLoadingtotalAgendamento && totalizadorAg.totalConfirmado} 
              </h3>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Icon>close</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>{t('agenda.schedules_canceled')} </p>
              <h3 className={classes.cardTitle}>
                {!isLoadingtotalAgendamento && totalizadorAg.totalCencelado} 
              </h3>
              {isLoadingtotalAgendamento && <label> <LoadingIcon className="rotate rsmall" /></label>}
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                {t('agenda.in_the_last_18_hours')}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Group />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('agenda.next_10_appointments')}
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer justify="space-between">
                <GridItem xs={12} sm={12} md={12}>
                  <Table
                    tableHead={[t('label.client'), t('label.service'), t('label.date')+"-"+t('label.time')]}
                    tableData={listProximos10}
                  />
                  {isLoadingProximos10 && <div>{t('label.loading')} ...</div>}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Face />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('label.professional')} x {t('agenda.appointments')}
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer justify="space-between">
                <GridItem xs={12} sm={12} md={12}>
                  <Table
                    tableHead={[t('label.professional'), t('label.total'), t('agenda.confirmed'), t('label.pending'), t('agenda.canceled')]}
                    tableData={listProfixAgend}
                  />
                  {isLoadingProfixAgend && <div>{t('label.loading')}...</div>}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>      
    </div>
  );
}

/*

Outros graficos para serem populados futuramente

<GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart className={classes.card}>
            <CardHeader color="info" className={classes.cardHeader}>
              <ChartistGraph
                className="ct-chart-white-colors"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Serviços Realizados</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                em relação a semana anterior
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart className={classes.card}>
            <CardHeader color="primary" className={classes.cardHeader}>
              <ChartistGraph
                className="ct-chart-white-colors"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Frequência de Clientes no Ano</h4>
              <p className={classes.cardCategory}>
                <span className={classes.dangerText}>
                  <ArrowDownward className={classes.upArrowCardCategory} /> 25%
                </span>{" "}
                em relação ao mês anterior
              </p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      */
